
<template>
 <div v-bind:class="{ savedWallsPicker: true, active: active, noSlickNav: itemsInRow >= savedWalls.length }">

 	<div v-if="savedWalls && savedWalls.length" id="savedWallsScroller" class="listing">

	     <div class="item hover-fade" v-on:click="pickItem(item)" v-for="(item, index) in savedWalls">
	       	<div class="inner">
				<div v-bind:style="{ backgroundImage: 'url('+getImage(item)+')' }" class="image relative">
					<loader classes="cover dimmer" fade-in="fadeIn" fade-out="fadeOut" :identifier="'pickWall'+item.id"></loader>
				    <div class="name"> {{ item.settings.name }} </div>
				    <div v-on:click="deleteItem(item, $event, index)" class="remove smooth">
				    	<loader :inline="true" classes="" :identifier="'deleteSave'+item.id"></loader>
				    	<i class="fa fa-trash"></i>
				    </div>
				</div>
	       	</div> <!-- inner -->

	     </div> <!-- item -->

	  </div> <!-- dataList -->

	  <div class="noSaves" v-if="!savedWalls.length && !loading">
	  	<div class="inner">
	  		<i class="fa fa-save"></i>
	  		<div class="text">{{ $t('noSavedWalls')}} </div>
	  	</div>  <!-- inner -->
	  </div>

	  <loader fade-in="fadeIn" fade-out="fadeOut" classes="cover dimmer" :loading="loading"></loader>

 </div> <!-- articlePicker -->

</template>

<script>

export default {

	data: function(){
		return{
			loading: false,
			savedWalls: false,
			frames: frames,
			itemsInRow: 0,
			imageUrl: window.appSettings.imageCloudUrl + "/c_fill,h_119,w_265",
			filter: {},
		}
	},

	computed: {
		active(){
			return this.$store.state.savedWallsPickerActive;
    	},

    	currentPictureWallArticles: function(){
    		return JSON.parse(this.$store.state.pictureWall.articles)
    	}

	},


	methods: {

		get: function(returnFunction){

			var self = this;
			var walls = [];

			window.apiHandler.getSavedWalls(function(data){

				if(data && data.length){

					$.each(data, function(index, wall){
						wall.settings = JSON.parse(wall.settings)
						walls.push(wall)
					})

					self.savedWalls = walls
				}
				else
					self.savedWalls = [];

				self.initSlider();

				if(typeof returnFunction != 'undefined')
					returnFunction()
			});

	    },

	    initSlider: function(){

	    	var savedWallsScroller = $("#savedWallsScroller")

	    	// Require slider
	    	require('../../../build/modules/slider.js')

	    	var self = this;

	    	// Define slide lengths
	    	var largeDesktopItems = 6;
	    	var desktopItems = 5;
	    	var tabletItems = 4;
	    	var mobileItems = 3;

	    	// Tell components which one we use
	    	var screenWidth =  $(window).width();
	    	if(screenWidth <= 813)
	    		self.itemsInRow = mobileItems;
	    	if(screenWidth > 813 && screenWidth <= 1024)
	    		self.itemsInRow = tabletItems;
	    	if(screenWidth > 1204)
	    		self.itemsInRow = desktopItems;
	    	if(screenWidth > 1500)
	    		self.itemsInRow = largeDesktopItems;

	    	window.vueRender(function(){
	    		$("#savedWallsScroller").slick({
			        infinite: false,
			        arrows: true,
			        dots: false,
			        slidesToShow: largeDesktopItems,
			        slidesToScroll: largeDesktopItems,
			         responsive: [
			          {
			            breakpoint: 1600,
			            settings: {
			              slidesToShow: desktopItems,
			              slidesToScroll: desktopItems
			            }
			          },
			          {
			            breakpoint: 1025,
			            settings: {
			              slidesToShow: tabletItems,
			              slidesToScroll: tabletItems
			            }
			          },
			          {
			            breakpoint: 813,
			            settings: {
			              slidesToShow: mobileItems,
			              slidesToScroll: mobileItems
			            }
			          }
			        ]
		    	}).slick('refresh')

	    	});

	    },

	    pickItem: function(item){

	    	var self = this;

	    	// Prompt to save if needed first
	    	self.promtSave(function(){

		    	// Start loading
		    	self.$store.commit('startLoading', 'pickWall'+item.id);

		    	// Hide left menus
		    	window.eventHub.$emit('closePickers');

				if(!item.id){
					self.promptError()
					self.$store.commit('stopLoading', 'pickWall'+item.id);
					return false;
				}

				// Pick background
				self.$store.commit('resetPictureWallColor')
				self.$store.commit('background', item.settings.background)

				// And color
				self.$store.commit('pictureWallColor', item.settings.pictureWallColor);

				// Create pictureWall object
				var pictureWallObject = {
					articles: item.settings.articles,
					name: item.settings.name,
					image: item.settings.picture
				};

				self.$store.commit('pictureWall', pictureWallObject);

				// Init choseable articles
				self.$store.commit('initChosenArticles', pictureWallObject.articles);

				// Get article data from API
				var idsToFetchFromAPi =  item.settings.skus.concat(item.settings.frames);

				window.apiHandler.specificArticles(function(data){

					// Create picked article array
					var chosenArticles = {};
					var chosenFrames = {};
					$.each(pictureWallObject.articles, function(index, pictureWallField){

						var id = index + 1;
						var currentSize = pictureWallField.size;

						// If we have an article
						if(typeof item.settings.skus[index] != 'undefined')
						{
							var idToSearchFor = item.settings.skus[index];

							$.each(data.products, function(index, product){
								if(product.id == idToSearchFor){
									$.each(product.combinations, function(index, combination){
										if(combination.size == currentSize){
											combination.images = product.images
											chosenArticles[id] = combination;
										}
									});
								}
							})

						}
						// If we have no article
						else
							chosenArticles[id] = false

						// Frames
						if(typeof item.settings.frames[index] != 'undefined'){

							var idToSearchFor = item.settings.frames[index];
							$.each(data.products, function(index, product){
								if(product.id == idToSearchFor){
									chosenFrames[id] = product
								}

							});
						}
						else
							chosenFrames[id] = false

					})

					self.$store.commit('chosenArticles', chosenArticles)

					// Calculate price
					setTimeout(function(){

						self.$store.commit('chosenFrames', chosenFrames)

						// Calculate price
						setTimeout(function(){
							self.$store.commit('calculatePrice');
						}, 5);

						// Save current wall save ID and tell no changed has been made
						self.$store.commit('currentWallID', {
							id: item.id,
							identifier: item.identifier,
						})
						self.$store.commit('currentWallName', item.settings.name)
						self.$store.commit('wallPicture', item.settings.picture)
						self.$store.commit('updated', false)
						self.setSavedUrl(item.id)
						self.$store.commit('stopLoading', 'pickWall'+item.id);

						// Emit event that tells a new picture wall has been selected
						window.eventHub.$emit('newPictureWall', pictureWallObject);

					}, 20);

				},
				{
					articles: idsToFetchFromAPi
				});

	    	});

      		self.trackEvent('picked saved wall');
	    },

	    deleteItem: function(item, event, index){

	    	var self = this;

	    	window.eventHub.$emit('openModal',
		    {
		        modal: 'message',
		        data: {
		          title: self.$t('removeTitle'),
		          messageClass: "longtext",
		          message: self.$t('removePromt'),
		          confirm: true,
		          confirmTxt: self.$t('remove'),
		          declineTxt: self.$t('close'),
		          primaryButton: 'decline',
		          onConfirm(){

		          	window.apiHandler.removeSave(function(data){

			    		if(data.status){
			    			var slickIndex = $(event.target).parents(".item").attr("data-slick-index");
			    			$("#savedWallsScroller").slick('slickRemove', slickIndex).slick('refresh');
			    			window.eventHub.$emit('closeModal')

			    			return true;
			    		}

			    		// Tell error if failed
			    		self.promptError(self.$t("couldNotRemove"))

					},{
						id: item.saved_id
					});

		          },
		          onDecline(){
		            window.eventHub.$emit('closeModal')
		          }
		        }
		    });


			event.stopPropagation();

	    },

	    getFrame: function(id){
	    	var self = this;

	    	var frame = false;

	    	$.each(this.frames, function(){
	    		if(this.id == id)
	    			frame = this;
	    	});

	    	return frame;
	    },

	    getImage: function(item){
	    	return this.imageUrl + item.settings.picture
	    },

		open: function(){
			this.$store.commit('savedWallsPickerActive', true);
			this.get();
		},

		close: function(){
			require('../../../build/modules/slider.js')
		  	$("#savedWallsScroller").slick('unslick');
		  	this.$store.commit('savedWallsPickerActive', false);
		  	this.savedWalls = false;
		},

		getArticleFieldID: function(itemNumber){
	      var index = itemNumber - 1;
	      return this.$store.state.pictureWall.fields[index].field_id;
	    },

	},

	created: function () {

		var self = this

		window.eventHub.$on('toggleSavedWalls', function () {

			window.eventHub.$emit('closeArticleFilter');
			window.eventHub.$emit('closeRightMenus', 'savedWalls');

			// Close if open to reload data
			if(self.active === true)
				self.close()
			else
				self.open()
		});

		window.eventHub.$on('refreshSavedWalls', function () {
			if(self.active === true)
				self.open()
		});

		// Close picker event
		window.eventHub.$on('closeRightMenus', function (type) {
			if(type != 'savedWalls')
				self.close()
		});


		// When we are picking a saved wall with events
	    window.eventHub.$on('pickSavedWall', function (item) {


			self.get(function(){
				$.each(self.savedWalls, function(index, wall){

					if(wall.id == item.id)
						self.pickItem(wall)
				})


			});

	    });

	}
}
</script>

<style>
.savedWallsPicker{

	width: 100%;
    height: 140px;
    overflow: hidden;
    position: absolute;
    border-bottom: 1px solid #eaeaea;
    -webkit-transform: translate3d(0,-210px,0);
    transform: translate3d(0,-210px,0);
    -webkit-transition: -webkit-transform 0.2s;
    transition: -webkit-transform 0.2s;
    -o-transition: transform 0.2s;
    transition: transform 0.2s;
    transition: transform 0.2s, -webkit-transform 0.2s;
    -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
    -o-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
    transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
    z-index: 9;
    background: white;
    top: 49px;

    padding: 0px 30px 0 calc(30px + 5px);

    &.noSlickNav{
    	padding: 0 10px;

    	@media screen and (max-width: 844px) {
			padding: 0 5px;
		}
    }

    /* Mobile */
	@media screen and (max-width: 844px) {
		height: 90px;
		bottom: calc(45px + env(safe-area-inset-bottom));
		top: auto;
		transform: translate3d(0,150px,0);
	}

	/* Set 100% height on all containers */
	.item, .inner, .slick-track, .slick-slider, .slick-list{
		height: 100% !important;
	}

	/* Fix slick navigation items */
	.slick-next, .slick-prev{
		margin-top: 3px;
		height: 100% !important;
	}

	.slick-prev{
		left: -27px;

		/* Mobile */
		@media screen and (max-width: 844px) {
			left: -28px
		}
	}

	.slick-next{
		right: -22px;

		/* Mobile */
		@media screen and (max-width: 844px) {
			right: -26px;
		}
	}

	.slick-slide > div{
		height: 100%;
	}

	/* Each list item */
    .item{

    	padding: 10px 10px 10px 0px;
    	height: 100%;

    	/* Tablets and desktop pop effect */
		@media screen and (min-width: 1024px) {
		 	&:active{
				img{
					transform: scale(1.1);
				}
		  	}
		}

    	/* Mobile */
	    @media screen and (max-width: 844px) {
    	    padding: 5px 5px 5px 0px;
    	}

    	.image{
    		height: 100%;
		    background-size: cover;
		    background-position: center;
		    min-width: 100px;
		    min-height: 100px;
    	}

    	.name{
    		position: absolute;
		    bottom: 0;
		    width: 100%;
		    background: rgba(0, 0, 0, 0.91);
		    font-size: 11px;
		    color: white;
		    text-align: center;
		    text-transform: uppercase;

		    padding: 6px;

		    /* Mobile */
			@media screen and (max-width: 844px) {
				padding: 3px;
			}
    	}

    	/* Remove */
    	.remove{
    		position: absolute;
    		opacity: 0;
		    top: 1px;
		    right: 1px;
		    padding: 4px 10px;
		    background: rgba(255, 255, 255, 0.85);

		    &:hover{
		    	background: white;
		    };

		    .remove{

		    }
    	}

    	&:hover .remove{
    		opacity: 1;
    	};

    	.loader i{
    		margin-top: 15%;

    		/* Mobile */
			@media screen and (max-width: 844px) {
				margin-top: 9%;
			}
    	}
    }


    .noSaves{
    	height: 100%;
    	display: table;
    	padding: 15px;

    	.inner{
    		display: table-cell;
    		height: 100%;
    		vertical-align: middle;
    		color: #b7b7b7;
    	}

    	.fa-save{
    		float: left;
    		font-size: 36px;

    		/* Mobile */
			@media screen and (max-width: 844px) {
				font-size: 28px;
			}
    	}

    	.text{
    		float: left;
		    margin-top: 8px;
		    margin-left: 8px;
		    font-weight: 300;
		    letter-spacing: 1px;
		    font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;

		    /* Mobile */
			@media screen and (max-width: 844px) {
				margin-top: 3px;
			}
    	}
    }
}

.savedWallsPicker.active{

	/* Mobile */
	-webkit-transform: translate3d(0,0,0);transform: translate3d(0,0,0);
}

</style>



// WEBPACK FOOTER //
// SavedWallsPicker.vue?f944245c